import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack } from '@chakra-ui/react';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackSpacing, formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';
import NameField from 'components/forms/new/formikFormFields/NameField';

const DescriptionField = ({ darkMode, errors, touched, mode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.description && touched.description}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Description
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter a description for this invoice line.
                    </Text>
                </Box>
                <Box flex="1" minWidth="250px">
                    <Box sx={{ display: 'flex', width: '100%', alignItems: 'flex-start', paddingTop: '8px' }}>
                        <VStack width="100%" alignItems="normal">
                            <Field
                                component={NameField}
                                id="description"
                                name="description"
                                isDisabled={mode === 'Delete'}
                                error={errors.description}
                                darkMode={darkMode}
                            />
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter a description for this invoice line"
                        ariaLabel="description-tip"
                        left="25px"
                        top="30px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default DescriptionField;